const LoginReducer = (state = {}, action) => {
  const { type, data } = action;
  switch (type) {
    case 'SET_COUNTRY_CODE': {
      return {
        ...state,
        countryCodes: data,
      };
    }
    case 'SET_FETCH_MODE': {
      return {
        ...state,
        encryptionKey: data,
      };
    }
    case 'MULTI_PROFILE': {
      return {
        ...state,
        profiles: data,
      };
    }
    case 'OTP_SENT': {
      return {
        ...state,
        OTPSent: data,
      };
    }
    case 'SET_LOGIN_ERROR_DATA': {
      return {
        ...state,
        errorString: data.str,
        tempToken: data.token,
      };
    }
    default: {
      return state;
    }
  }
};

export default LoginReducer;
